module.exports = __webpack_public_path__ + "static/img/zuodengnisi.e80a088.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/zuodengnisi.png
// module id = 0nHK
// module chunks = 1